<template>
  <register-form />
</template>

<script>
import RegisterForm from "@/components/register-form.vue";
export default {
  components: {
    RegisterForm
  }
};
</script>
